namespace Areas.Drawing.Classify {

    "use strict";

    let projectId = 0;
    let runQuery: boolean = false;

    var drawingGrid: DevExpress.ui.dxDataGrid;
    var buildingGrid: DevExpress.ui.dxDataGrid;
    var drawingTypeGrid: DevExpress.ui.dxDataGrid;
    var designProfessionalDisciplineGrid: DevExpress.ui.dxDataGrid;
    const saveButtonName: string = "SaveButton";
    const deleteButtonName: string = "DeleteButton";
    const markButtonName: string = "MarkCompleteButton";

    $(() => { init(); });

    function init() {
        drawingGrid = $("#DataEntryDrawingDataGrid").dxDataGrid("instance");
        buildingGrid = $("#BuildingDataGrid").dxDataGrid("instance");
        drawingTypeGrid = $("#DataEntryDrawingTypesGrid").dxDataGrid("instance");
        designProfessionalDisciplineGrid = $("#DataEntryDesignProfessionalDisciplinesGrid").dxDataGrid("instance");
    }

    export function sortGridColumn(e: any) {
        //return 1;
        var val = $("#DataEntryDesignProfessionalDisciplinesGrid").dxDataGrid("instance").getSelectedRowKeys().indexOf(e);
        if (val > -1)
        { return 0; }
        else
        { return -1; }
    }

    export function columnViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= '/Project/Profile/View/{placeholder}'>View</a>";

        buildCellContent(cellElement,
            () => { return cellInfo.data.projectId; },
            linkInfo);
    }

    export function refreshGrid(e: any) {
        e.component.refresh();
    }

    export function projectSelected(e: any) {
        projectId = e.selectedRowKeys[0];
        runQuery = true;
        getDrawings();
    }

    function getDrawings() {      
        drawingGrid.deselectAll();  
        drawingGrid.getDataSource().reload();
        buildingGrid.deselectAll();
        buildingGrid.refresh();
        drawingTypeGrid.deselectAll();
        designProfessionalDisciplineGrid.deselectAll();
        Areas.disableButton(saveButtonName);
        Areas.disableButton(markButtonName); 
    }

    export function drawingSelected(e: any) {
        if (drawingGrid.getSelectedRowKeys().length > 0) {
            Areas.enableButton(saveButtonName);
            Areas.enableButton(deleteButtonName);
            Areas.enableButton(markButtonName);
        } else {
            Areas.disableButton(saveButtonName);
            Areas.disableButton(deleteButtonName);
            Areas.disableButton(markButtonName);
        }
    }

    export function saveClassification() {
        const record = getRecord();
        sendRequest("/Drawing/Classify/AddDrawingsClassification", JSON.stringify(record), "POST",
        (data) => drawingGrid.refresh());
    }

    export function removeClassification() {
        const record = getRecord();
        sendRequest("/Drawing/Classify/RemoveDrawingsClassification", JSON.stringify(record), "POST",
        (data) => drawingGrid.refresh());
    }  
    
    function getRecord() : any {
        return {
            drawings: drawingGrid.getSelectedRowKeys(),
            buildingProjects: buildingGrid.getSelectedRowKeys(),
            drawingTypes: drawingTypeGrid.getSelectedRowKeys(),
            designProfessionalDisciplines: designProfessionalDisciplineGrid.getSelectedRowKeys()
        };
    }

    export function markDrawingsComplete() {
        var drawingIds = drawingGrid.getSelectedRowKeys();
        sendRequest("/Drawing/Classify/MarkDrawingsComplete", JSON.stringify(drawingIds), "POST", 
            () => { getDrawings(); });
    }    

    export function getProjectId() {
        return projectId;
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function downloadDrawingLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.drawingId; },
            "<a href= '/File/Get/Drawing/{placeholder}'>Download</a>");
    }   
    
    let currentStep = 1;

    export function nextNavigation() {
        incrementStep();
        updateView();
    }

    export function backNavigation() {
        decrementStep();
        updateView();
    } 
    
    function incrementStep() {
        currentStep++;
        if (currentStep > 3) {
            currentStep = 1;
        }
    } 

    function decrementStep() {
        currentStep--;
        if (currentStep < 0) {
            currentStep = 3;
        }
    } 

    export function updateView() {
        switch (currentStep) {
            case 1:
                showElement("projects-area");
                hideElement("classification-area");
                hideElement("classification-areabutton");
                updateElementText("navigation-detailtext", "Select project for editing. <br>In Record Drawing Grid select cell for editing.  Right click to copy cell information down to multiple cells, that are checked marked and yellow. Click save upon completion.");
                Areas.hideButton("MarkCompleteButton")
                Areas.hideButton("BackButton");
                enableDrawingGrid();
                break;

            case 2:
                hideElement("projects-area");
                showElement("classification-area");
                showElement("classification-areabutton");
                disableDrawingGrid();
                updateElementText("navigation-detailtext", "Populates only 3 columns.<br> Building, Types and Design Professional Columns");
                Areas.hideButton("MarkCompleteButton")
                Areas.showButton("BackButton");
                break;  
                
            case 3:
                hideElement("classification-area");
                hideElement("classification-areabutton");
                updateElementText("navigation-detailtext", "Lock records that are completed.  They become visible to the general users.");
                Areas.showButton("MarkCompleteButton")
                Areas.showButton("BackButton");
                break;                
            default:
                break;
        }

        updateElementText("navigation-text", currentStep.toString());
    }

    let gridEditingSettings: any;

    function disableDrawingGrid() {
        const editSettings = drawingGrid.option("editing");
        gridEditingSettings = {mode: editSettings.mode, allowUpdating: editSettings.allowUpdating, allowAdding: editSettings.allowAdding, allowDeleting: editSettings.allowDeleting};
        drawingGrid.option("editing", { mode: "batch", allowUpdating: false, allowAdding: false, allowDeleting: false });
    }

    function enableDrawingGrid() {
        drawingGrid.option("editing", gridEditingSettings);
    }

    function showElement(id: string) {
        $(`#${id}`).css("visibility", "visible");
        $(`#${id}`).css("display", "block");
    }

    function hideElement(id: string) {
        $(`#${id}`).css("visibility", "hidden");
        $(`#${id}`).css("display", "none");
    }

    function updateElementText(id: string, text: string) {
        $(`#${id}`).html(text);
    }
}